if (!customElements.get('ff-newsletter-languages')) {
  customElements.define(
    'ff-newsletter-languages',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const form = this.closest('form');
          const { hash } = new URL(form.action);
          form.action = event.target.value + hash;
        });
      }
    }
  );
}
